module.exports = __webpack_public_path__ + "img/28.f205aebe.jpg";